import React from 'react';

type Props = React.SVGAttributes<SVGSVGElement>;

export const CloseIcon: React.FC<Props> = (props) => (
  <svg width="9" height="9" viewBox="0 0 9 9" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.49996 3.79289L8.0355 0.257355L8.74261 0.964462L5.20707 4.5L8.74261 8.03553L8.0355 8.74264L4.49996 5.2071L0.964431 8.74264L0.257324 8.03553L3.79286 4.5L0.257324 0.964462L0.964431 0.257355L4.49996 3.79289Z" />
  </svg>
);
